<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a [routerLink]="['/home']">Home</a></li>
      <li class="breadcrumb-item"><a [routerLink]="['/smart-irrigation/regions']">Smart Irrigation</a></li>
      <li class="breadcrumb-item"><a (click)="goBack()" style="cursor:pointer">{{ node?.name || 'Parks' }}</a></li>
      <li class="breadcrumb-item active"><strong>Water Usage</strong></li>
    </ol>
  </div>
  <div class="col-lg-2 d-flex align-items-center justify-content-end gap-2">
    <small class="text-muted" *ngIf="lastRefresh">{{ lastRefresh | date:'d MMM yyyy HH:mm' }}</small>
    <button class="btn btn-outline-white btn-sm" (click)="load()" [disabled]="loading" title="Refresh">
      <i class="fa fa-sync" [class.fa-spin]="loading"></i>
    </button>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight pt-3">
  <div class="alert alert-info" *ngIf="loading">
    <i class="fa fa-spinner fa-spin me-2"></i> Loading water usage data&hellip;
  </div>

  <div class="alert alert-warning" *ngIf="!loading && noData">
    No water meter data found for this park.
    <a (click)="goBack()" style="cursor:pointer" class="alert-link">Go back</a>
  </div>

  <ng-container *ngIf="!loading && !noData">
    <div class="st-chart-card" *ngIf="hourlyChartOptions">
      <div class="st-chart-card__title">Hourly Usage &#8212; 7-Day History</div>
      <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="hourlyChartOptions" style="width:100%;height:300px;display:block;"></highcharts-chart>
    </div>

    <div class="st-chart-card" *ngIf="dailyChartOptions">
      <div class="st-chart-card__title">Daily Usage &#8212; 30-Day History</div>
      <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="dailyChartOptions" style="width:100%;height:300px;display:block;"></highcharts-chart>
    </div>

    <div class="st-chart-card" *ngIf="weeklyChartOptions">
      <div class="st-chart-card__title">Weekly Usage &#8212; 3-Month History</div>
      <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="weeklyChartOptions" style="width:100%;height:300px;display:block;"></highcharts-chart>
    </div>

    <div class="st-chart-card" *ngIf="monthlyChartOptions">
      <div class="st-chart-card__title">Monthly Usage &#8212; 12-Month History</div>
      <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="monthlyChartOptions" style="width:100%;height:300px;display:block;"></highcharts-chart>
    </div>

    <div class="st-trend-note st-trend-note--muted" *ngIf="!hourlyChartOptions && !dailyChartOptions && !weeklyChartOptions && !monthlyChartOptions">
      No historical water usage data is available for this period.
    </div>
  </ng-container>
</div>
